/**
 * @file poOwnership.js
 * @version 1.2.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-05
 * @modified 2026-10-20
 * @description A PO made in Xero (a Xero id, not LOCAL-/TEMP-) is read-only
 *              here, whatever the Xero PO sync switch says (Cam, 2026-10-05).
 *              Its cost is set from its bill. The server's rule is
 *              utils/poOwnership.xeroMadePoRefusal; this is the screen's copy
 *              for rows the server did not describe. From 2026-10-06 its cost
 *              price can be changed (the narrowed Edit window,
 *              PoCostSuppliedModal) and is sent to Xero.
 *              1.2.0 (2026-10-20, Cam): that holds only while the Xero PO
 *              sync is on; nightly / off a Xero-made PO is edited here like a
 *              PO made here (the server sends editBlock null and
 *              xeroCostOnly false). Its cost changes still go to Xero.
 */

export const XERO_MADE_PO_READ_ONLY = 'This PO was made in Xero and the Xero PO sync is on, so only its cost price can be changed here — in Edit, or from its bill — and the change is sent to Xero.';

/** Is this Xero PO id one Xero made (not a LOCAL-/TEMP- placeholder)? */
export const isXeroMadePoId = (id) => {
  const s = String(id || '').trim();
  return s !== '' && !/^(TEMP-|LOCAL-)/i.test(s);
};
